import {
  Stepper as StepperMui,
  StepperProps as StepperPropsMui,
} from '@mui/material';

export type StepperProps = StepperPropsMui;

export function Stepper({ ...rest }: StepperProps) {
  return <StepperMui {...rest} />;
}
